import React from "react";
import { Link } from "react-router-dom";
import { Brand } from "./Nav";
import AppStoreBadge from "./AppStoreBadge";
import { CONTACT_EMAIL, INSTAGRAM_URL } from "./config";

export default function Footer() {
  return (
    <footer className="foot" data-testid="site-footer">
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <Brand />
            <p className="foot-tag">
              The maths friend your child teaches. Made in England for children who deserve better
              than worksheets.
            </p>
            <div style={{ marginTop: 20 }}>
              <AppStoreBadge small testId="footer-app-store" />
            </div>
          </div>
          <div>
            <h4>Leo</h4>
            <ul>
              <li><a href="/#listen">Listen in</a></li>
              <li><a href="/#how">How it works</a></li>
              <li><a href="/#parents">For parents</a></li>
              <li><a href="/#pricing">Pricing</a></li>
            </ul>
          </div>
          <div>
            <h4>Help</h4>
            <ul>
              <li><a href="/#faq">FAQ</a></li>
              <li><Link to="/contact" data-testid="footer-contact-link">Contact</Link></li>
              <li><a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact-email">{CONTACT_EMAIL}</a></li>
            </ul>
          </div>
          <div>
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy" data-testid="footer-privacy-link">Privacy policy</Link></li>
              <li><Link to="/terms" data-testid="footer-terms-link">Terms of use</Link></li>
              <li><a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link">Instagram</a></li>
            </ul>
          </div>
        </div>
        <div className="foot-base">
          <span>© {new Date().getFullYear()} Meet Leo. All rights reserved.</span>
          <span>UK curriculum aligned · UK GDPR · No ads, ever</span>
        </div>
        <div className="foot-word" aria-hidden>
          leo
        </div>
      </div>
    </footer>
  );
}
